const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const html = document.documentElement;
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
let fmt;
try { fmt = new Intl.NumberFormat(html.lang || 'en', { style: 'currency', currency: cur }); } catch { fmt = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }); }
const cents = (c) => fmt.format(c / 100);
const dollars = (d) => fmt.format(parseFloat(d) || 0);
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const store = {
  get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
};

let evMod = null;
const evReady = import('@shopify/events').then((m) => (evMod = m)).catch(() => null);


const lock = (on) => (on ? html.setAttribute('scroll-lock', '') : html.removeAttribute('scroll-lock'));
function openDlg(dlg) {
  if (!dlg.open) dlg.showModal();
  lock(true);
}
function wireDlg(dlg) {
  dlg.addEventListener('close', () => { if (!$('dialog.nx-dlg[open]')) lock(false); });
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg || e.target.closest('[data-dlg-close]')) dlg.close();
  });
}
function toast(msg) {
  let t = $('.nx-toast');
  if (!t) {
    t = document.createElement('div');
    t.className = 'nx-toast nx-surface';
    t.setAttribute('role', 'status');
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.remove('is-on');
  void t.offsetWidth;
  t.classList.add('is-on');
  clearTimeout(t._h);
  t._h = setTimeout(() => t.classList.remove('is-on'), 2600);
}

/* Command palette: Cmd/Ctrl+K or "/" opens live predictive search */
function initPalette() {
  const dlg = $('#nx-palette');
  if (!dlg) return;
  wireDlg(dlg);
  const input = $('input', dlg);
  const list = $('[data-pal-list]', dlg);
  const idle = $('[data-pal-idle]', dlg);
  const recentBox = $('[data-pal-recent]', dlg);
  let rows = [];
  let active = -1;
  let ctrl = null;
  let timer = 0;

  const recent = () => store.get('nx-recent', []);
  const remember = (q) => store.set('nx-recent', [q, ...recent().filter((x) => x !== q)].slice(0, 5));

  const renderIdle = () => {
    const r = recent();
    recentBox.innerHTML = r.length
      ? '<p class="nx-pal__label">Recent</p><div class="nx-pal__chips">' + r.map((q) => `<button type="button" class="nx-chip" data-q="${esc(q)}">${esc(q)}</button>`).join('') + '</div>'
      : '';
    idle.hidden = false;
    list.hidden = true;
    list.innerHTML = '';
    rows = [];
    active = -1;
    input.removeAttribute('aria-activedescendant');
  };

  const setActive = (i, scroll = true) => {
    const els = $$('[role=option]', list);
    if (!els.length) return;
    active = (i + els.length) % els.length;
    els.forEach((el, n) => el.setAttribute('aria-selected', String(n === active)));
    input.setAttribute('aria-activedescendant', els[active].id);
    if (scroll) els[active].scrollIntoView({ block: 'nearest' });
  };

  const render = (q, data) => {
    rows = [];
    const res = (data && data.resources && data.resources.results) || {};
    (res.products || []).forEach((p) => rows.push({ group: 'Products', title: p.title, url: p.url, img: sized((p.featured_image && p.featured_image.url) || p.image, 120), meta: dollars(p.price), sold: p.available === false }));
    const seen = new Set();
    (res.collections || []).forEach((c) => { if (seen.has(c.title)) return; seen.add(c.title); rows.push({ group: 'Collections', title: c.title, url: c.url, meta: 'Collection' }); });
    (res.pages || []).forEach((c) => rows.push({ group: 'Pages', title: c.title, url: c.url, meta: 'Page' }));
    rows.push({ group: 'Search', title: `Search everything for “${q}”`, url: `${root}search?q=${encodeURIComponent(q)}`, meta: '', all: true });
    let g = '';
    list.innerHTML = rows.map((r, i) => {
      const head = r.group !== g ? `<li class="nx-pal__group" role="presentation">${(g = r.group)}</li>` : '';
      const thumb = r.img ? `<img src="${esc(r.img)}" alt="" width="44" height="44" loading="lazy">` : `<span class="nx-pal__go">&rarr;</span>`;
      return `${head}<li role="option" id="nx-opt-${i}" data-i="${i}" aria-selected="false"><a href="${esc(r.url)}" tabindex="-1">${thumb}<span class="nx-pal__t">${esc(r.title)}</span><span class="nx-pal__m nx-mono${r.sold ? ' is-sold' : ''}">${r.sold ? 'Sold out' : esc(r.meta)}</span></a></li>`;
    }).join('');
    idle.hidden = true;
    list.hidden = false;
    setActive(0, false);
  };

  const search = async (q) => {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    try {
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=5&resources[options][unavailable_products]=last`;
      const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error(r.status);
      if (input.value.trim() !== q) return;
      render(q, await r.json());
    } catch (e) {
      if (e.name === 'AbortError') return;
      rows = [{ url: `${root}search?q=${encodeURIComponent(q)}` }];
      list.innerHTML = `<li role="option" id="nx-opt-0" aria-selected="true"><a href="${root}search?q=${encodeURIComponent(q)}"><span class="nx-pal__go">&rarr;</span><span class="nx-pal__t">Search everything for “${esc(q)}”</span></a></li>`;
      idle.hidden = true;
      list.hidden = false;
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) return renderIdle();
    timer = setTimeout(() => search(q), 110);
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      const q = input.value.trim();
      if (!q) return;
      remember(q);
      location.href = rows[active] ? rows[active].url : `${root}search?q=${encodeURIComponent(q)}`;
    }
  });
  list.addEventListener('pointermove', (e) => {
    const li = e.target.closest('[role=option]');
    if (li && +li.dataset.i !== active) setActive(+li.dataset.i, false);
  });
  list.addEventListener('click', () => { const q = input.value.trim(); if (q) remember(q); });
  dlg.addEventListener('click', (e) => {
    const b = e.target.closest('[data-q]');
    if (b) { input.value = b.dataset.q; input.dispatchEvent(new Event('input')); input.focus(); }
  });

  const open = () => {
    openDlg(dlg);
    input.value = '';
    renderIdle();
    requestAnimationFrame(() => input.focus());
  };
  window.nxOpenPalette = open;

  window.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); dlg.open ? dlg.close() : open(); }
    else if (e.key === '/' && !e.metaKey && !e.ctrlKey && !/^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '') && !(e.target && e.target.isContentEditable) && !dlg.open) { e.preventDefault(); open(); }
  });
  window.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[on\\:click="#search-modal/showDialog"], [data-nx-search]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);
}

/* Cart plumbing: uses the theme's own events so the drawer and bubble update natively */
async function addToCart(variantId, quantity, productId, source) {
  await evReady;
  const routes = (window.Theme && Theme.routes) || {};
  const ids = $$('cart-items-component').map((e) => e.dataset.sectionId).filter(Boolean).join(',');
  const deferred = evMod && evMod.CartLinesUpdateEvent.createPromise();
  if (evMod) {
    source.dispatchEvent(new evMod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity }], promise: deferred.promise }));
  }
  try {
    const res = await fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity, sections: ids }),
    });
    const json = await res.json();
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (json.status) {
      if (deferred) deferred.resolve({ cart: evMod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'nx-quick', sourceId: 'nx-quick', itemCount: quantity, productId: String(productId) } });
      return { ok: false, message: json.description || json.message || 'Could not add to cart' };
    }
    if (deferred) deferred.resolve({ cart: evMod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'nx-quick', sourceId: 'nx-quick', itemCount: quantity, productId: String(productId), sections: json.sections, didError: false } });
    return { ok: true, cart };
  } catch (err) {
    if (deferred) deferred.reject(err);
    return { ok: false, message: 'Network error, try again' };
  }
}

/* Quick add: variant picker sheet on any product card */
function initQuick() {
  const dlg = $('#nx-quick');
  if (!dlg) return;
  wireDlg(dlg);
  const body = $('[data-q-body]', dlg);
  let product = null;
  let sel = [];
  let qty = 1;
  let busy = false;

  const names = () => product.options.map((o) => (typeof o === 'string' ? o : o.name));
  const variant = () => product.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
  const values = (i) => [...new Set(product.variants.map((v) => v.options[i]))];
  const inStock = (i, val) => product.variants.some((v) => v.options[i] === val && v.options.every((o, j) => j === i || o === sel[j]) && v.available);

  const draw = () => {
    const v = variant();
    const single = product.variants.length === 1;
    const img = (v && v.featured_image && v.featured_image.src) || product.featured_image;
    const groups = single ? '' : names().map((n, i) => `
      <fieldset class="nx-opt"><legend>${esc(n)} <b>${esc(sel[i])}</b></legend>
        <div class="nx-opt__row">${values(i).map((val) => `<button type="button" class="nx-opt__chip${val === sel[i] ? ' is-on' : ''}${inStock(i, val) ? '' : ' is-out'}" data-opt="${i}" data-val="${esc(val)}" aria-pressed="${val === sel[i]}">${esc(val)}</button>`).join('')}</div>
      </fieldset>`).join('');
    const price = v ? `<span class="nx-q__price nx-mono">${cents(v.price)}</span>${v.compare_at_price > v.price ? `<s class="nx-mono">${cents(v.compare_at_price)}</s>` : ''}` : '';
    const can = v && v.available;
    body.innerHTML = `
      <div class="nx-q__media"><img src="${esc(sized(img, 900))}" alt="${esc(product.title)}"></div>
      <div class="nx-q__info">
        <p class="nx-q__type">${esc(product.type || product.vendor || '')}</p>
        <h2 class="nx-q__title">${esc(product.title)}</h2>
        <p class="nx-q__priceRow">${price}</p>
        ${groups}
        <div class="nx-q__buy">
          <div class="nx-step" role="group" aria-label="Quantity"><button type="button" data-step="-1" aria-label="Decrease">−</button><output>${qty}</output><button type="button" data-step="1" aria-label="Increase">+</button></div>
          <button type="button" class="nx-btn nx-btn--sun nx-q__add" data-add ${can && !busy ? '' : 'disabled'}>${can ? (busy ? 'Adding…' : `Add to cart · ${cents(v.price * qty)}`) : 'Sold out'}</button>
        </div>
        <a class="nx-q__more nx-link" href="${esc(product.url)}">View full details</a>
      </div>`;
  };

  body.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-opt]');
    if (chip) { sel[+chip.dataset.opt] = chip.dataset.val; return draw(); }
    const st = e.target.closest('[data-step]');
    if (st) { qty = clamp(qty + +st.dataset.step, 1, 20); return draw(); }
    const add = e.target.closest('[data-add]');
    if (add && !busy) {
      const v = variant();
      if (!v) return;
      busy = true;
      draw();
      const res = await addToCart(v.id, qty, product.id, dlg);
      busy = false;
      if (res.ok) { dlg.close(); } else { draw(); toast(res.message); }
    }
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-nx-quick]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    body.innerHTML = '<div class="nx-q__loading"><i></i></div>';
    openDlg(dlg);
    qty = 1;
    try {
      product = await fetch(`${root}products/${b.dataset.nxQuick}.js`, { headers: { Accept: 'application/json' } }).then((r) => { if (!r.ok) throw 0; return r.json(); });
      const first = product.variants.find((v) => v.available) || product.variants[0];
      sel = [...first.options];
      draw();
    } catch {
      dlg.close();
      toast('Could not load that product');
    }
  });
}

/* Wishlist: hearts on cards, header counter, saved drawer (localStorage) */
function initSaved() {
  const KEY = 'nx-saved';
  const dlg = $('#nx-saved');
  const get = () => store.get(KEY, []);
  const actions = $('.nx-actions');
  let badge = null;
  if (actions && !$('[data-nx-saved-open]')) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'nx-round nx-saved-btn';
    b.setAttribute('data-nx-saved-open', '');
    b.setAttribute('aria-label', 'Saved items');
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.7 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.3 0 5.4 3.3 4.2 6.7-1.7 4.7-9.2 9.3-9.2 9.3z"/></svg><span class="nx-count" hidden></span>';
    actions.insertBefore(b, actions.children[1] || null);
    badge = $('.nx-count', b);
  }
  const sync = () => {
    const s = new Set(get());
    $$('[data-nx-save]').forEach((b) => {
      const on = s.has(b.dataset.nxSave);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    if (badge) { badge.textContent = s.size; badge.hidden = s.size === 0; }
  };
  window.nxSyncSaved = sync;

  const renderList = async () => {
    const box = $('[data-s-list]', dlg);
    const handles = get();
    if (!handles.length) { box.innerHTML = '<div class="nx-s__empty"><p class="nx-h2" style="font-size:1.8rem">Nothing saved yet.</p><p class="nx-lede">Tap the heart on anything you love and it will wait for you here.</p></div>'; return; }
    box.innerHTML = '<div class="nx-q__loading"><i></i></div>';
    const items = (await Promise.all(handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    box.innerHTML = items.map((p) => `
      <div class="nx-s__row">
        <a href="${esc(p.url)}" class="nx-s__img"><img src="${esc(sized(p.featured_image, 200))}" alt="" loading="lazy"></a>
        <div class="nx-s__txt"><a href="${esc(p.url)}">${esc(p.title)}</a><span class="nx-mono">${cents(p.price)}</span>
          <div class="nx-s__btns"><button type="button" class="nx-btn nx-btn--sun nx-btn--sm" data-nx-quick="${esc(p.handle)}">Quick add</button><button type="button" class="nx-btn nx-btn--ghost nx-btn--sm" data-s-remove="${esc(p.handle)}">Remove</button></div>
        </div>
      </div>`).join('');
  };

  document.addEventListener('click', (e) => {
    const h = e.target.closest('[data-nx-save]');
    if (h) {
      e.preventDefault();
      e.stopPropagation();
      const handle = h.dataset.nxSave;
      const s = get();
      const i = s.indexOf(handle);
      if (i > -1) { s.splice(i, 1); toast('Removed from saved'); } else { s.unshift(handle); toast('Saved'); h.classList.add('is-pop'); setTimeout(() => h.classList.remove('is-pop'), 700); }
      store.set(KEY, s);
      sync();
      if (dlg && dlg.open) renderList();
      return;
    }
    const rm = e.target.closest('[data-s-remove]');
    if (rm) { store.set(KEY, get().filter((x) => x !== rm.dataset.sRemove)); sync(); renderList(); return; }
    if (e.target.closest('[data-nx-saved-open]') && dlg) { openDlg(dlg); renderList(); }
  });
  if (dlg) wireDlg(dlg);
  addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
  sync();
}

/* Dock: live "buy 3, get 10% off" progress tied to the real cart */
async function initDock() {
  const el = $('#nx-dock');
  if (!el) return;
  const T = +el.dataset.threshold || 3;
  const P = +el.dataset.percent || 10;
  const label = $('[data-dock-text]', el);
  const sub = $('[data-dock-sub]', el);
  let was = null;
  // Once clicked, the dock stays dismissed for the rest of the visit.
  const KEY_OFF = 'nx-dock-off';
  const off = () => { try { return sessionStorage.getItem(KEY_OFF) === '1'; } catch (e) { return false; } };
  const burst = () => {
    if (reduced()) return;
    for (let i = 0; i < 16; i++) {
      const s = document.createElement('i');
      s.className = 'nx-spark';
      const a = (i / 16) * Math.PI * 2;
      const d = 46 + Math.random() * 40;
      s.style.setProperty('--dx', Math.cos(a) * d + 'px');
      s.style.setProperty('--dy', Math.sin(a) * d - 10 + 'px');
      s.style.setProperty('--h', 20 + Math.random() * 40);
      el.appendChild(s);
      setTimeout(() => s.remove(), 1000);
    }
  };
  const paint = (n) => {
    const left = Math.max(0, T - n);
    el.hidden = n === 0 || off();
    el.style.setProperty('--p', clamp(n / T));
    const unlocked = left === 0;
    el.classList.toggle('is-unlocked', unlocked);
    label.textContent = unlocked ? `${P}% off unlocked` : `Add ${left} more, get ${P}% off`;
    sub.textContent = unlocked ? 'Applied automatically at checkout' : `${n} of ${T} in your cart`;
    if (unlocked && was !== null && was < T) burst();
    was = n;
  };
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => paint(c.item_count)).catch(() => {});
  el.addEventListener('click', () => {
    try { sessionStorage.setItem(KEY_OFF, '1'); } catch (e) {}
    el.hidden = true;
    const t = $('[data-testid="cart-drawer-trigger"]'); if (t) t.click(); else location.href = '/cart';
  });
  await evReady;
  if (evMod) {
    document.addEventListener(evMod.StandardEvents.cartLinesUpdate, (e) => {
      if (e.promise) e.promise.then(refresh).catch(() => {});
      else refresh();
    });
  }
  refresh();
  addEventListener('pageshow', refresh);
}


function initProgress() {
  if ($('.nx-progress')) return;
  const bar = document.createElement('div');
  bar.className = 'nx-progress';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<i></i>';
  document.body.appendChild(bar);
  const fill = bar.firstChild;
  const pw = $('.page-wrapper');
  const upd = () => {
    const desk = matchMedia('(min-width: 990px)').matches && pw;
    const st = desk ? pw.scrollTop : window.scrollY;
    const max = desk ? pw.scrollHeight - pw.clientHeight : html.scrollHeight - innerHeight;
    fill.style.transform = `scaleX(${max > 0 ? clamp(st / max) : 0})`;
  };
  addEventListener('scroll', upd, { passive: true });
  if (pw) pw.addEventListener('scroll', upd, { passive: true });
  upd();
}

function boot() {
  initPalette();
  initQuick();
  initSaved();
  initDock();
  initProgress();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
else boot();
document.addEventListener('shopify:section:load', () => window.nxSyncSaved && window.nxSyncSaved());
